<script setup lang="ts">
import type { SectionLeadRecord } from '~/types/datocms'

defineProps<{
  data: SectionLeadRecord
  moduleIndex: number
}>()

enum ALIGN {
  LEFT = 'Left',
  RIGHT = 'Right'
}

enum BACKGROUND_VARIANT {
  BLACK = 'Black',
  YELLOW = 'Yellow',
  CREAM = 'Cream'
}

const handleExternalLink = (button: CtaRecord) => {
  if (!button.recordLink && !button.externalLink) {
    console.warn(`No link provided for "${button.title}" call to action`, button)
    return undefined
  } else if (button.externalLink?.startsWith('#')) {
    return {
      path: useLocalePathByType(
        button.recordLink?._modelApiKey ?? '',
        button.recordLink?.slug as string
      ),
      hash: button.externalLink
    }
  } else if (button.externalLink?.startsWith('?')) {
    return (
      useLocalePathByType(
        button.recordLink?._modelApiKey ?? '',
        button.recordLink?.slug as string
      ) + button.externalLink
    )
  } else if (button.externalLink?.startsWith('http')) {
    return button.externalLink
  } else if (button.recordLink) {
    return useLocalePathByType(button.recordLink?._modelApiKey, button.recordLink?.slug as string)
  }
}
</script>

<template>
  <section
    class="py-4 lg:py-10"
    :class="[
      data.backgroundVariant === BACKGROUND_VARIANT.BLACK && 'bg-black text-yellow',
      data.backgroundVariant === BACKGROUND_VARIANT.YELLOW && 'bg-yellow text-black',
      data.backgroundVariant === BACKGROUND_VARIANT.CREAM && 'bg-cream text-black'
    ]"
  >
    <div class="container grid-default gap-y-6 text-lg">
      <div
        class="col-span-full uppercase lg:col-span-6"
        :class="data.align === ALIGN.RIGHT ? 'lg:order-2 lg:col-start-7' : ''"
        v-html="data.text"
      />
      <div
        v-if="data.links?.length"
        class="col-span-full flex flex-col text-sm text-grey-light lg:col-span-6"
        :class="data.align === ALIGN.LEFT ? 'lg:items-end' : 'lg:order-1'"
      >
        <template v-for="(link, idx) in data.links" :key="idx">
          <HyperLink
            class="w-fit py-1 transition-colors duration-300 hover:text-yellow lg:py-2"
            :class="link.color === 'Cream' ? 'text-cream' : 'text-grey-light'"
            :to="handleExternalLink(link.link)"
            :target="link.link?.externalLink?.startsWith('http') ? '_blank' : undefined"
            :content="link.link?.title ?? ''"
          />
        </template>
      </div>
    </div>
  </section>
</template>
